export const testimonials = [
  {
    id: 1,
    name: '漫画迷小琳',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20avatar%2C%20friendly%20smile%2C%20casual%20style%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20natural%20look%2C%20clean%20headshot%2C%20professional%20but%20approachable&width=200&height=200&seq=avatar-01&orientation=squarish',
    content: '从大学开始就在韩国漫画网看韩漫了，更新速度真的超快！画质清晰，阅读体验一流。现在每天通勤路上必刷，已经是生活中不可或缺的一部分了。',
    rating: 5,
    platform: '微博',
  },
  {
    id: 2,
    name: '书虫老张',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20avatar%2C%20friendly%20expression%2C%20casual%20hoodie%2C%20warm%20lighting%2C%20clean%20cream%20background%2C%20natural%20look%2C%20relaxed%20vibe%2C%20clean%20headshot&width=200&height=200&seq=avatar-02&orientation=squarish',
    content: '分类特别全，想看的韩漫基本都能找到。页面没有乱七八糟的广告弹窗，这点太重要了！收藏夹功能也很方便，追更不会断。',
    rating: 5,
    platform: '知乎',
  },
  {
    id: 3,
    name: '追更达人阿喵',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20female%20portrait%20avatar%2C%20warm%20smile%2C%20casual%20sweater%2C%20soft%20lighting%2C%20clean%20cream%20background%2C%20natural%20beauty%2C%20friendly%20look%2C%20simple%20headshot&width=200&height=200&seq=avatar-03&orientation=squarish',
    content: '我独自升级、全知读者视角这些热门韩漫翻译质量很高，而且更新几乎同步韩国。推荐给了好几个朋友，都说好用！界面确实很清爽。',
    rating: 5,
    platform: '小红书',
  },
];

export const statsData = [
  { label: '收录漫画', value: '10,000+', suffix: '部' },
  { label: '活跃读者', value: '500', suffix: '万' },
  { label: '每日更新', value: '200+', suffix: '话' },
  { label: '完全免费', value: '100', suffix: '%' },
];

export const features = [
  '界面友好',
  '操作简单',
  '更新迅速',
  '无遮挡阅读',
];